/**
 * Traditional Chinese (TWD + HKD) mock schedules for the scheduled-
 * transactions use case. A schedule with both source and destination accounts
 * is a schedule pair, rendered by DoubleRow.
 */

/** @type {Array<import('../../mock-schedules.js').MockSchedule>} */
export const MOCK_SCHEDULES_ZH_TW = [
	{
		id: 'sch-1',
		nextDate: '2026-08-27',
		transactionType: 'Credit Card Payment',
		estimatedAmount: 84318,
		currencySymbol: 'NT$',
		currencyDecimalPlaces: 0,
		displayAccount: '常綠銀行',
		displayFreq: 'Monthly',
		description: '港島返利卡繳費',
	},
	{
		id: 'sch-2',
		nextDate: '2026-08-10',
		transactionType: 'Withdrawal',
		estimatedAmount: 35200,
		currencySymbol: 'NT$',
		currencyDecimalPlaces: 0,
		displayAccount: '常綠銀行',
		displayFreq: 'Monthly',
		description: '房租',
	},
	{
		id: 'sch-3',
		nextDate: '2026-08-15',
		transactionType: 'Regular Investment',
		estimatedAmount: 124800,
		currencySymbol: 'NT$',
		currencyDecimalPlaces: 0,
		displayAccount: '常綠銀行',
		displayFreq: 'Monthly',
		description: '基金定投',
	},
	{
		id: 'sch-4',
		nextDate: '2026-08-05',
		transactionType: 'Deposit',
		estimatedAmount: 112000,
		currencySymbol: 'NT$',
		currencyDecimalPlaces: 0,
		displayAccount: '常綠銀行',
		displayFreq: 'Monthly',
		description: '薪水',
	},
	{
		id: 'sch-5',
		isSchedulePair: true,
		nextDate: '2026-09-01',
		transactionType: 'Transfer',
		estimatedAmount: 16000,
		currencySymbol: 'NT$',
		currencyDecimalPlaces: 0,
		displayAccount: '常綠銀行',
		displaySourceAccount: '常綠銀行',
		displayDestAccount: '定期存款',
		displayFreq: 'Monthly',
		description: '存入儲蓄',
		pairedType: 'Transfer',
		pairedCurrencySymbol: 'NT$',
		pairedCurrencyDecimalPlaces: 0,
	},
];
